import React from "react";
import { Skeleton } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";

const ViewProfitLossReport = ({ isData, isLoading }) => {
  const { isUser } = useAuth();
  return (
    <>
      <div className="table-responsive rtable">
        <table className="table table-sm table-bordered text-center">
          <tbody>
            <tr>
              <td className="fw-600">PROFIT-LOSS REPORT</td>
            </tr>
          </tbody>
        </table>

        <div className="d-flex rtable">
          <div className="w-50">
            <table className="table table-sm table-bordered">
              <tbody>
                <tr>
                  <td className="w-25">Name</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      isData?.reportInfo?.store?.title || ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="w-25">From Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.reportInfo?.fromdate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.reportInfo?.fromdate,
                          isUser?.timezone,
                        ),
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="w-25">To Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.reportInfo?.todate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.reportInfo?.todate,
                          isUser?.timezone,
                        ),
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="w-25">No of Sales</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `${
                        isData?.reportSummary?.saleSummary?.totalNoOfSale || 0
                      }`
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="w-10"></div>

          {/* <div className="w-50 rtable">
            <table className="table table-sm table-bordered mb-0 text-center">
              <tbody>
                <tr>
                  <td className="w-25 fw-500">Base Total</td>
                  <td className="w-25 fw-500">GST Total</td>
                  <td className="w-25 fw-500">Grand Total</td>
                </tr>
                <tr>
                  <td className="fw-600">
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(isData?.reportSummary?.totalBasePrice) || 0,
                        "INR"
                      )}`
                    )}
                  </td>
                  <td className="fw-600">
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(isData?.reportSummary?.totalTaxAmount) || 0,
                        "INR"
                      )}`
                    )}
                  </td>
                  <td className="fw-600">
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(isData?.reportSummary?.grandTotal) || 0,
                        "INR"
                      )}`
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div> */}
        </div>

        <table className="table table-sm table-bordered mb-3 rtable">
          <tbody>
            <tr>
              <td className="text-center">S No</td>
              <td className="text-center">No</td>
              <td className="text-center">Date</td>
              <td className="w-45 text-center">Title</td>
              <td className="text-center">Quantity</td>
              {/* <td className="text-center">Unit</td> */}
              <td className="text-center">Tax</td>
              <td className="text-center">Sale Price</td>
              <td className="text-center">LandingCost</td>
              <td className="text-center">Profit</td>
              <td className="text-center">Profit Without Tax </td>
            </tr>
          </tbody>
          <tbody>
            {isLoading ? (
              [...Array(11)].map((_, index) => (
                <tr key={index}>
                  {[...Array(9)].map((__, i) => (
                    <td key={i} className="text-center">
                      <Skeleton variant="text" width={i === 0 ? 300 : 200} />
                    </td>
                  ))}
                </tr>
              ))
            ) : Array.isArray(isData?.reportData) &&
              isData?.reportData?.length > 0 ? (
              isData?.reportData?.map((item, index) => (
                <tr key={item?.id || index}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{item?.saleno}</td>
                  <td className="text-center">
                    {
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          item?.saleDate,
                          isUser?.timezone,
                        ),
                      ).date
                    }
                  </td>
                  <td className="text-center">{item?.title || ""}</td>
                  <td className="text-center">
                    {item?.quantity} {item?.unitConfig?.primaryUnitCode}
                  </td>
                  {/* <td className="text-center">
                    <span className="badge btn-unit">
                      {item?.unitConfig?.primaryUnitCode || "-"}
                    </span>
                  </td> */}
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      item?.lineTotalTaxAmount || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      item?.lineTotalSoldPrice || 0,
                      "INR",
                    )}
                  </td>

                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      item?.lineTotalLandingCost || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      Number(item?.lineTotalProfit) || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      item?.lineTotalProfitWithoutTax || 0,
                      "INR",
                    )}
                  </td>
                  {/* <td className="text-center">
                    {item.saleby?.storename || ""}
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center p-2">
                  <small className="text-muted">
                    No sale found in the store. add some customers to get
                    started.
                  </small>
                </td>
              </tr>
            )}
          </tbody>
          <tbody>
            <tr>
              <td colSpan="5" className="text-center"></td>
              {/* <td className="text-center fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    isData?.reportSummary?.totalMrp || 0,
                    "INR"
                  )}`
                )}
              </td> */}
              <td className="text-center fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    isData?.reportSummary?.saleSummary?.totalTaxAmount || 0,
                    "INR",
                  )}`
                )}
              </td>
              <td className="text-center fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    isData.reportSummary?.saleSummary?.totalSoldPrice || 0,
                    "INR",
                  )}`
                )}
              </td>
              <td className="text-center fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    isData?.reportSummary?.saleSummary?.totalLandingCost || 0,
                    "INR",
                  )}`
                )}
              </td>
              <td className="text-center fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    isData?.reportSummary?.saleSummary?.totalProfit || 0,
                    "INR",
                  )}`
                )}
              </td>
              <td className="text-center fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    isData?.reportSummary?.saleSummary?.totalProfitWithoutTax ||
                      0,
                    "INR",
                  )}`
                )}
              </td>
              {/* <td className="text-center"></td> */}
            </tr>
          </tbody>
        </table>
        {/* 
        <table className="table table-sm table-bordered mb-0 rtable w-30">
          <tbody>
            <tr>
              <td className="w-25">Cash</td>
              <td>
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    Number(isData?.cashamount) || 0,
                    "INR"
                  )}`
                )}
              </td>
            </tr>
            <tr>
              <td className="w-25">Card</td>
              <td>
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    Number(isData?.cardamount) || 0,
                    "INR"
                  )}`
                )}
              </td>
            </tr>
            <tr>
              <td className="w-25">Online Pay (UPI)</td>
              <td>
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    Number(isData?.onlineamount) || 0,
                    "INR"
                  )}`
                )}
              </td>
            </tr>
            <tr>
              <td className="w-25">Discount</td>
              <td>
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    Number(isData?.totaldiscount) || 0,
                    "INR"
                  )}`
                )}
              </td>
            </tr>
          </tbody>
        </table> */}
      </div>
    </>
  );
};

export default ViewProfitLossReport;
